import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import styles from './styles';

function UTTextArea({ onChange, onBlur, onFocus, value, style, disabled, placeholder }) {
  return (
    <textarea
      style={[styles.textarea, style]}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}

UTTextArea.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string
};

export default Radium(UTTextArea);
